import { combineReducers, configureStore } from '@reduxjs/toolkit';
import configSlice from './slices/ConfigSlice';
import brandSlice from './slices/BrandSlice';
import userSlice from './slices/UserSlice';
import contentSlice from './slices/ContentSlice';
import customerSlice from './slices/CustomerSlice';

/**
 * Root reducer used to create the Redux store.
 */
const rootReducer = combineReducers({
  appConfig: configSlice,
  brand: brandSlice,
  content: contentSlice,
  user: userSlice,
  customer: customerSlice
});

/**
 * Creates a configured Redux store.
 *
 * @param preloadedState Optional initial state used for hydration/testing.
 */
export const setupStore = (preloadedState?: Partial<RootState>) =>
  configureStore({
    reducer: rootReducer,
    preloadedState
  });

/**
 * Default singleton store instance.
 */
export const store = setupStore();

/**
 * Root state type.
 */
export type RootState = ReturnType<typeof rootReducer>;

/**
 * App dispatch type.
 */
export type AppDispatch = typeof store.dispatch;

/**
 * Store instance type.
 */
export type AppStore = ReturnType<typeof setupStore>;
